// extracted by mini-css-extract-plugin
var _1 = "Ni89i";
var _2 = "a7Ps_";
export { _1 as "sidebarHidden", _2 as "sidebarVisible" }
